/* Login identity helpers (kept out of Login.tsx so the component file only exports components). */

export interface StoredUser {
  id: string; name: string; role: string; status: string;
  password?: string; twoFA: boolean; permissions: Record<string, unknown>;
  department?: string; mobile?: string;
}

/* The user as the SERVER says after a valid password / OTP: id, role and name
   come from the login response (profile first, then top-level role/name), the
   local cached entry only fills what the server left out. A role cached in this
   browser never outranks the server's. */
export type AuthReply = { role?: unknown; name?: unknown; profile?: Partial<StoredUser> & Record<string, unknown> };
export function userFromServer(local: StoredUser | undefined | null, typedId: string, data: AuthReply): StoredUser {
  const p = (data && data.profile) || {};
  const s = (v: unknown) => (typeof v === 'string' && v.trim() ? v.trim() : '');
  return {
    ...(local || {}),
    id: s(p.id) || (local ? local.id : '') || typedId,
    name: s(p.name) || s(data && data.name) || (local ? local.name : '') || typedId,
    role: (s(p.role) || s(data && data.role) || (local ? local.role : '') || 'USER').toUpperCase(),
    status: s(p.status) || (local ? local.status : '') || 'ACTIVE',
    twoFA: typeof p.twoFA === 'boolean' ? p.twoFA : (local ? local.twoFA : false),
    permissions: (p.permissions as Record<string, unknown>) || (local ? local.permissions : {}) || {},
    department: s(p.department) || (local ? local.department : undefined),
  };
}

